(function () {
  const sort = document.querySelector('.mobile-sort');
  const form = document.getElementById('FacetFiltersFormMobile');
  if (!sort || !form) return;

  const valueEl = sort.querySelector('.mobile-sort__value');
  const radios = sort.querySelectorAll('input[name="sort_by"]');

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (valueEl) {
        const nameEl = radio.closest('.facet-checkbox');
        const name = nameEl ? nameEl.querySelector('.label') : null;
        valueEl.textContent = name ? name.textContent.trim() : radio.value;
      }

      sort.removeAttribute('open');

      form.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
})();
